import React, { useState } from 'react';
import { Field, Formik } from 'formik';
import { useMutation } from '@apollo/client';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Form as FormSemantic } from 'semantic-ui-react';
import { ErrorHandler, InputFormField } from '@playbookux/playbook-web-core';
import {
  ButtonSave,
  ContainerButton,
  Modal,
  Text,
  TextArea,
} from './styles';

import schema from '../schemas';

import {
  CREATE_FOLDER_GROUP,
  UPDATE_FOLDER_GROUP,
  updateCacheOnCreateFolderGroup,
} from '../../../../core/graphql/folders';

const ModalFolderGroup = (props) => {
  const {
    companyId,
    editGroup,
    onClose,
  } = props;

  const {
    id,
    description: editDescription,
    name: editName,
  } = editGroup;

  const [
    createFolderGroup,
    { loading, error },
  ] = useMutation(CREATE_FOLDER_GROUP, {
    update: updateCacheOnCreateFolderGroup(companyId),
  });

  const [
    updateFolderGroup,
    { loading: loadingUpdate, error: errorUpdate },
  ] = useMutation(UPDATE_FOLDER_GROUP);

  const isEdit = !_.isEmpty(editGroup);

  const [errorMsg, setErrorMsg] = useState(null);

  const handleCloseModal = () => {
    onClose();
  };

  const handleCreateOrUpdateGroup = async (values) => {
    setErrorMsg(null);

    const {
      description = '',
      name,
    } = values;

    try {
      if (isEdit) {
        await updateFolderGroup({
          variables: {
            id,
            attributes: {
              name,
              description,
            },
          },
        });

        handleCloseModal();
      } else {
        await createFolderGroup({
          variables: {
            name,
            description,
            companyId,
          },
        });

        handleCloseModal();
      }
    } catch (err) {
      const resu = _.get(err, 'networkError.result.error',
        { message: 'Something went wrong while updating the folder group' });
      setErrorMsg(resu);
    }
  };

  return (
    <Modal
      closeOnEscape
      closeOnDimmerClick
      open
      onClose={onClose}
    >
      <Text as="h1">{isEdit ? `Edit ${editName}` : 'Create Folder Group'}</Text>
      <Formik
        initialValues={{
          name: editName || '',
          description: editDescription || '',
        }}
        validationSchema={schema}
        onSubmit={({ ...res }) => handleCreateOrUpdateGroup(res)}
      >
        {({
          errors,
          setFieldValue,
          handleSubmit,
          values,
        }) => (
          <FormSemantic onSubmit={handleSubmit}>
            <FormSemantic.Field>
              <Text as="h2">Name</Text>
              <Field
                name="name"
                error={errors.name}
                placeholder="Name folder group"
                component={InputFormField}
              />

            </FormSemantic.Field>

            <Text as="h2">Description</Text>

            <TextArea
              value={values.description}
              name="description"
              placeholder="Describe the folder group (optional)"
              onChange={(x, { value }) => {
                setFieldValue('description', value, false);
              }}
            />

            <ContainerButton>

              { (error || errorUpdate || errorMsg) && (
                <ErrorHandler
                  error={error || errorUpdate || errorMsg}
                  defaultMessage="Error while creating or updating the folder group"
                />
              )}

              <ButtonSave
                loading={loading || loadingUpdate}
                type="submit"
              >
                Save
              </ButtonSave>
            </ContainerButton>
          </FormSemantic>
        )}
      </Formik>
    </Modal>
  );
};

ModalFolderGroup.propTypes = {
  editGroup: PropTypes.shape({
    color: PropTypes.string,
    description: PropTypes.string,
    name: PropTypes.string,
    id: PropTypes.string,
  }),
  errors: PropTypes.shape({
    name: PropTypes.string,
  }),
  companyId: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  values: PropTypes.shape({
    description: PropTypes.string,
  }),
};

ModalFolderGroup.defaultProps = {
  editGroup: {
    id: '',
    color: '',
    description: '',
    name: '',
  },
  values: {
    description: '',
  },
  errors: {},
};

export default ModalFolderGroup;
